var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"iframe-contain",staticClass:"iframe-contain"},[(_vm.showSpin)?_c('Spin',{attrs:{"size":"large","fix":""}}):_vm._e(),_c('iframe',{ref:"iframe-detail",attrs:{"width":"1140","height":"541.25","src":_vm.iframe_path,"frameborder":"0","allowFullScreen":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }